<ng-template #loaderBlock>
  <ng-container *ngIf="!chartData">
    <app-loader></app-loader>
  </ng-container>
</ng-template>
<svg
  [attr.width]="svgWidth"
  [attr.height]="svgHeight"
  id="revenueMarginChart">
</svg>
<ng-container *ngIf="!loading; else loaderBlock"></ng-container>

